export const GUIDE_FILTERS_INITIAL_STATE = {
  fromDate: '',
  toDate: '',
  busqueda: '',
  guideNumber: '',
  party: '',
  estadoLogistico: '',
  estadoComercial: '',
  line: '',
  branchId: '',
  invoiceStatus: '',
  collectionStatus: '',
  paymentCondition: '',
  foja: '',
  reparto: '',
  remitoNumber: '',
  sender: '',
  receiver: '',
  address: '',
};

export const GUIDE_FILTER_LABELS = {
  fromDate: 'Fecha desde',
  toDate: 'Fecha hasta',
  busqueda: 'Busqueda',
  guideNumber: 'Nro guia',
  party: 'Cliente / interviniente',
  estadoLogistico: 'Estado logistico',
  estadoComercial: 'Estado comercial',
  line: 'Línea',
  branchId: 'Sucursal',
  invoiceStatus: 'Estado de facturación',
  collectionStatus: 'Estado de cobranza',
  paymentCondition: 'Condicion de pago',
  foja: 'Foja',
  reparto: 'Reparto',
  remitoNumber: 'Nro remito',
  sender: 'Remitente',
  receiver: 'Destinatario',
  address: 'Domicilio',
};

export const GUIDE_FILTER_FIELDS = {
  fromDate: {
    name: 'fromDate',
    label: 'Fecha desde',
    type: 'date',
  },
  toDate: {
    name: 'toDate',
    label: 'Fecha hasta',
    type: 'date',
  },
  guideNumber: {
    name: 'guideNumber',
    label: 'Nro guia',
    type: 'text',
    placeholder: 'Ej: 10023',
  },
  party: {
    name: 'party',
    label: 'Cliente / remitente / destinatario',
    type: 'text',
    placeholder: 'Nombre o razon social',
  },
  estadoLogistico: {
    name: 'estadoLogistico',
    label: 'Estado logistico',
    type: 'select',
    options: [
      { value: '', label: 'Todos' },
      { value: 'EMITIDA', label: 'Emitida' },
      { value: 'EN_FOJA', label: 'En foja' },
      { value: 'FOJA_CERRADA', label: 'Foja cerrada' },
      { value: 'RECIBIDA_DESTINO', label: 'Recibida destino' },
      { value: 'EN_REPARTO', label: 'En reparto' },
      { value: 'ENTREGADA', label: 'Entregada' },
      { value: 'RETENIDA', label: 'Retenida' },
      { value: 'REPROGRAMADA', label: 'Reprogramada' },
      { value: 'ANULADA', label: 'Anulada' },
    ],
  },
  estadoComercial: {
    name: 'estadoComercial',
    label: 'Estado comercial',
    type: 'select',
    options: [
      { value: '', label: 'Todos' },
      { value: 'SIN_VALORIZAR', label: 'Sin valorizar' },
      { value: 'PENDIENTE_VALORIZACION', label: 'Pendiente valorizacion' },
      { value: 'VALORIZADA', label: 'Valorizada' },
      { value: 'FACTURADA', label: 'Facturada' },
    ],
  },
  line: { name: 'line', label: 'Línea', type: 'text', placeholder: 'Ej: 3300-00000002' },
  branchId: { name: 'branchId', label: 'Sucursal', type: 'number', placeholder: 'ID de sucursal' },
  invoiceStatus: { name: 'invoiceStatus', label: 'Estado de facturación', type: 'text', placeholder: 'Ej: PENDIENTE' },
  collectionStatus: { name: 'collectionStatus', label: 'Estado de cobranza', type: 'text', placeholder: 'Ej: PENDIENTE' },
  paymentCondition: {
    name: 'paymentCondition',
    label: 'Condicion de pago',
    type: 'select',
    options: [
      { value: '', label: 'Todas' },
      { value: 'ORIGEN', label: 'Origen' },
      { value: 'DESTINO', label: 'Destino' },
    ],
  },
  foja: {
    name: 'foja',
    label: 'Foja',
    type: 'text',
    placeholder: 'Ej: 1052',
  },
  reparto: {
    name: 'reparto',
    label: 'Reparto',
    type: 'text',
    placeholder: 'Ej: 208',
  },
  remitoNumber: {
    name: 'remitoNumber',
    label: 'Nro remito',
    type: 'text',
    placeholder: 'Ej: R-889',
  },
  sender: {
    name: 'sender',
    label: 'Remitente',
    type: 'text',
    placeholder: 'Nombre o razon social',
  },
  receiver: {
    name: 'receiver',
    label: 'Destinatario',
    type: 'text',
    placeholder: 'Nombre o razon social',
  },
  address: {
    name: 'address',
    label: 'Domicilio entrega',
    type: 'text',
    placeholder: 'Direccion de entrega',
  },
};

export const GUIDE_FILTER_GROUPS = [
  { id: 'dates', fields: ['fromDate', 'toDate'], columns: 2 },
  { id: 'status', fields: ['estadoLogistico', 'estadoComercial', 'paymentCondition', 'invoiceStatus', 'collectionStatus'], columns: 2 },
  { id: 'numbers', fields: ['guideNumber', 'line', 'branchId', 'foja', 'reparto', 'remitoNumber'], columns: 2 },
  { id: 'clients', fields: ['party', 'sender', 'receiver'], columns: 2 },
  { id: 'address', fields: ['address'], columns: 1 },
];

export function buildGuideFilters(state) {
  return Object.entries(state).reduce((acc, [key, value]) => {
    if (!value) {
      return acc;
    }
    const trimmed = typeof value === 'string' ? value.trim() : value;
    if (trimmed) {
      acc[key] = trimmed;
    }
    return acc;
  }, {});
}

export function summarizeGuideFilters(filters) {
  const entries = Object.entries(filters);
  if (!entries.length) {
    return 'Ninguno';
  }
  return entries
    .map(([key, value]) => `${GUIDE_FILTER_LABELS[key] || key}: ${value}`)
    .join(' · ');
}

export function buildGuidesQueryParams(filters, { page, limit, sortBy, sortDirection } = {}, extraFilters = {}) {
  const params = new URLSearchParams();

  if (filters?.busqueda) {
    params.set('busqueda', filters.busqueda);
  }
  if (filters?.guideNumber) {
    params.set('nro_guia', filters.guideNumber);
  }
  if (filters?.party) {
    params.set('cliente', filters.party);
  }
  if (filters?.fromDate) {
    params.set('fecha_desde', filters.fromDate);
  }
  if (filters?.toDate) {
    params.set('fecha_hasta', filters.toDate);
  }
  if (filters?.sender) {
    params.set('remitente', filters.sender);
  }
  if (filters?.receiver) {
    params.set('destinatario', filters.receiver);
  }
  if (filters?.remitoNumber) {
    params.set('remito', filters.remitoNumber);
  }
  if (filters?.address) {
    params.set('domicilio', filters.address);
  }
  if (filters?.estadoLogistico) {
    params.set('estado_logistico', filters.estadoLogistico);
  }
  if (filters?.estadoComercial) {
    params.set('estado_comercial', filters.estadoComercial);
  }
  if (filters?.paymentCondition) {
    params.set('condicion_pago', filters.paymentCondition);
  }
  if (filters?.foja) {
    params.set('foja', filters.foja);
  }
  if (filters?.reparto) {
    params.set('reparto', filters.reparto);
  }
  if (filters?.line) params.set('linea', filters.line);
  if (filters?.branchId) params.set('sucursal_id', filters.branchId);
  if (filters?.invoiceStatus) params.set('estado_facturacion', filters.invoiceStatus);
  if (filters?.collectionStatus) params.set('estado_cobranza', filters.collectionStatus);

  Object.entries(extraFilters || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.set(key, value);
    }
  });

  if (page) {
    params.set('page', String(page));
  }
  if (limit) {
    params.set('limit', String(limit));
  }
  if (sortBy) {
    params.set('ordenar_por', sortBy);
  }
  if (sortDirection) {
    params.set('orden', sortDirection);
  }

  return params;
}
